import CircularRectTextButton from "@/components/CircularButton/styled/CircularRectTextButton";
import { FlexRowAlignCenter } from "@/components/Flex";
import { spacing } from "@/utils/spacing";
import { themeColors } from "@/utils/themeColors";
import { useEffect, useRef, useState } from "react";

const SortingIndicator = ({
    sortedKnow,
    sortedDontKnow,
}: { sortedKnow: number | undefined; sortedDontKnow: number | undefined }) => {
    const [knowAnimating, setKnowAnimating] = useState(false);
    const [dontKnowAnimating, setDontKnowAnimating] = useState(false);

    const prevKnow = useRef(sortedKnow);
    const prevDontKnow = useRef(sortedDontKnow);

    // Trigger animation for "Know"
    useEffect(() => {
        if (sortedKnow !== undefined && prevKnow.current !== undefined && sortedKnow > prevKnow.current) {
            setKnowAnimating(true);
            const timeout = setTimeout(() => setKnowAnimating(false), 300); // Match animation duration
            return () => clearTimeout(timeout);
        }
        prevKnow.current = sortedKnow;
    }, [sortedKnow]);

    // Trigger animation for "Don't Know"
    useEffect(() => {
        if (
            sortedDontKnow !== undefined &&
            prevDontKnow.current !== undefined &&
            sortedDontKnow > prevDontKnow.current
        ) {
            setDontKnowAnimating(true);
            const timeout = setTimeout(() => setDontKnowAnimating(false), 300); // Match animation duration
            return () => clearTimeout(timeout);
        }
        prevDontKnow.current = sortedDontKnow;
    }, [sortedDontKnow]);

    return (
        <FlexRowAlignCenter style={{ justifyContent: "space-between" }}>
            <FlexRowAlignCenter style={{ gap: spacing.XS, position: "relative" }}>
                <CircularRectTextButton
                    className="secondaryTextBold1"
                    disabled
                    sx={{
                        border: `2px solid ${themeColors.errorPrimary}`,
                        color: dontKnowAnimating ? themeColors.errorSecondary : themeColors.errorPrimary,
                        marginLeft: "auto",
                        backgroundColor: dontKnowAnimating ? themeColors.errorPrimary : themeColors.errorSecondary,
                        width: "3.7rem",
                        height: "3.2rem",
                        borderRadius: "2rem",
                        fontWeight: 800,
                        transition: "background-color 0.15s ease",
                    }}>
                    {dontKnowAnimating ? "+1" : sortedDontKnow}
                </CircularRectTextButton>
                <p className="secondaryTextBold1" style={{ color: themeColors.errorPrimary }}>
                    Don't Know
                </p>
            </FlexRowAlignCenter>
            <FlexRowAlignCenter style={{ gap: spacing.XS, position: "relative" }}>
                <p className="secondaryTextBold1" style={{ color: themeColors.primary }}>
                    Know
                </p>
                <CircularRectTextButton
                    className="secondaryTextBold1"
                    disabled
                    sx={{
                        border: `2px solid ${themeColors.primary}`,
                        color: knowAnimating ? themeColors.primaryLight : themeColors.primary,
                        marginLeft: "auto",
                        backgroundColor: knowAnimating ? themeColors.primary : themeColors.primaryLight,
                        width: "3.7rem",
                        height: "3.2rem",
                        borderRadius: "2rem",
                        fontWeight: 800,
                        transition: "background-color 0.15s ease",
                    }}>
                    {knowAnimating ? "+1" : sortedKnow}
                </CircularRectTextButton>
            </FlexRowAlignCenter>
        </FlexRowAlignCenter>
    );
};

export default SortingIndicator;
